/* eslint-disable no-nested-ternary */
import { PropsWithChildren } from "react";
import { ITradeModalProps } from "./PerpsTradeForm.types";
import { usePerpsTradeFormSetup } from "./usePerpsTradeFormSetup";
import { usePerpsTradeFormEffects } from "./usePerpsTradeFormEffects";
import { usePerpsTradeFormFees } from "./usePerpsTradeFormFees";
import { usePerpsTradeFormCreateOrder } from "./usePerpsTradeFormCreateOrder";
import { usePerpsTradeFormValidators } from "./usePerpsTradeFormValidators";
import { usePerpsTradeFormNotional } from "./usePerpsTradeFormNotional";
import { usePerpsTradeFormMax } from "./usePerpsTradeFormMax";
import { usePerpsTradeFormSizing } from "./usePerpsTradeFormSizing";
import { usePerpsTradeFormSubmit } from "./usePerpsTradeFormSubmit";
import { usePerpsTradeFormSubmitSpot } from "./usePerpsTradeFormSubmitSpot";
import PerpsTradeFormView from "./PerpsTradeForm.View";

function PerpsTradeForm(props: PropsWithChildren<ITradeModalProps>) {
  const c1 = usePerpsTradeFormSetup(props);
  const c2 = usePerpsTradeFormEffects(c1);
  const c3 = usePerpsTradeFormFees(c2);
  const c4 = usePerpsTradeFormCreateOrder(c3);
  const c5 = usePerpsTradeFormValidators(c4);
  const c6 = usePerpsTradeFormNotional(c5);
  const c6b = usePerpsTradeFormMax(c6);
  const c7 = usePerpsTradeFormSizing(c6b);
  const c8 = usePerpsTradeFormSubmit(c7);
  const ctx = usePerpsTradeFormSubmitSpot(c8);

  return <PerpsTradeFormView ctx={ctx} />;
}

export type {
  IPerpsFormDefaultValues,
  ITradeModalProps,
} from "./PerpsTradeForm.types";

export default PerpsTradeForm;
